/* eslint no-inline-comments: 0 */

const List = () => import( /* webpackChunkName: "group-url-shortener" */ `./list.vue` );
const Add = () => import( /* webpackChunkName: "group-url-shortener" */ `./add.vue` );
const Edit = () => import( /* webpackChunkName: "group-url-shortener" */ `./edit.vue` );

export default {
	path: `url-shortener`,
	children: [
		{
			path: ``,
			name: `list-redirects`,
			component: List,
			meta: {
				title: `URL Shortener`
			}
		},
		{
			path: `new`,
			name: `add-redirect`,
			component: Add,
			meta: {
				title: `Add Redirect`
			}
		},
		{
			path: `:uuid`,
			name: `edit-redirect`,
			component: Edit,
			meta: {
				title: `Edit Redirect`
			}
		}
	]
};
